import {Component, Inject, OnInit} from '@angular/core';
import { ConfigTituloPaginasService } from '@appNeo/core/services/config-titulo-paginas.service';
import {LEGALTXT} from '@appNeo/pages/pages/aviso-legal/aviso-legal-data';

@Component({
  selector: 'neo-pagina-aviso-legal',
  templateUrl: './pagina-aviso-legal.component.html',
  styleUrls: ['./pagina-aviso-legal.component.scss']
})
export class PaginaAvisoLegalComponent implements OnInit {


  constructor(@Inject(LEGALTXT) public legalTxt,
    private configTitulo: ConfigTituloPaginasService
  ) { }

  ngOnInit(): void {
    this.configTitulo.establecerTitulo('Aviso Legal de ZONAFAN: Términos y Condiciones');
    this.configTitulo.establecerMeta('Aviso Legal de ZONAFAN para conocer nuestros términos y condiciones. Protegemos tu privacidad y garantizamos transparencia en nuestras prácticas');
  }

}
